module.exports = __webpack_public_path__ + "static/media/bullseye-pointer-light.4e7419ed.svg";